import React, { Component } from 'react';
import { TaggisLogo } from '../../atoms';
import { NavItemGroup } from '../../molecules';
import ContentConverter from '../../../utils/contentConverter';

import './styles.css';

/**
 * The template for the footer for the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object[]} navItems
 * @prop {String} address
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
export default class Footer extends Component {

	/**
	 * @param {{ replace: (arg0: string, arg1: number) => any; }} content
	 */
	genContent = (content) => content
		.replace('{year}', new Date().getFullYear());

	/**
	 * @param {String} address
	 */
	getAddress = (address) => new ContentConverter(address).nlToBr().convertLinks().getReactHtml();

	render () {
		const navItems = this.props.navItems;
		const {
			content,
			address,
		} = this.props;

		return (
			<div className='Footer'>
				<TaggisLogo animated={true} className='Footer-logo' />
				<div className='Footer-nav'>
					<NavItemGroup className='Footer-navItems' navItems={navItems} />
				</div>
				<address className='Footer-address' dangerouslySetInnerHTML={this.getAddress(address)} />
				<p className='Footer-copy'>{this.genContent(content)}</p>
			</div>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/molecules/Footer/Footer.js